<template>
  <div class="reset-password-page">
    <div class="container">
      <h2>Восстановление пароля</h2>
      <form>
        <input
          type="password"
          v-model="newPassword"
          @input="checkPassword"
          placeholder="Новый пароль"
        />
        <input
          type="password"
          v-model="repeatPassword"
          placeholder="Повторите пароль"
        />
        <div class="alert" v-if="error">{{ error }}</div>
        <div class="success-message" v-if="success">
          ✅ Пароль успешно изменён. <router-link to="/">Войти</router-link>
        </div>
        <button
          @click="submit"
          :disabled="loading"
          class="submit-btn"
          type="button"
        >
          {{ loading ? "Сохраняем..." : "Сохранить пароль" }}
        </button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import AuthService from "@/services/auth";

const route = useRoute();
const router = useRouter();

const userId = route.params.uid;
const token = route.params.token;

const newPassword = ref("");
const repeatPassword = ref("");
const error = ref("");
const success = ref(false);
const loading = ref(false);

const checkPassword = () => {
  const minLength = /.{8,}/; // Проверка на минимальную длину (8+ символов)
  const hasDigit = /[0-9]/; // Проверка на наличие хотя бы одной цифры
  const hasSpecialChar = /[!@#$%^&*()_+<>?-]/; // Проверка на наличие специального символа

  if (!minLength.test(newPassword.value)) {
    error.value = "Пароль должен содержать минимум 8 символов.";
  } else if (!hasDigit.test(newPassword.value)) {
    error.value = "Пароль должен содержать хотя бы одну цифру.";
  } else if (!hasSpecialChar.test(newPassword.value)) {
    error.value = "Пароль должен содержать хотя бы один специальный символ.";
  } else {
    error.value = null;
  }
};

const submit = async () => {
  if (newPassword.value !== repeatPassword.value) {
    error.value = "Пароли не совпадают";
    return;
  }
  if (newPassword.value.length < 8) {
    error.value = "Пароль слишком короткий";
    return;
  }

  error.value = "";
  loading.value = true;

  const user = ref({
    uid: userId,
    token: token,
    new_password: newPassword,
  });
  const text = ref(null);

  try {
    AuthService.resetPasswordConfirm(user.value)
      .then((response) => {
        text.value = "Ваш пароль успешно обновлен";
        return Promise.resolve(response);
      })
      .catch((error) => {
        alert("Не удалось обновить пароль");
        return Promise.reject(error);
      });
    success.value = true;
  } catch (e) {
    console.error(e);
    error.value = "Ошибка. Ссылка может быть недействительна.";
  } finally {
    loading.value = false;
  }
};
</script>
<style lang="scss" scoped>
.reset-password-page {
  background: linear-gradient(137deg, #00c782 0%, #016542 100%);
  padding: 60px 0 0 0;
  color: white;
  min-height: calc(100vh - 86px);
  display: flex;
  flex-direction: column;
  .error {
    color: red;
  }
  .container {
    max-width: 1200px;
    margin: auto;
    padding: 0 20px;
  }
  form {
    display: flex;
    flex-direction: column;

    input[type="text"],
    input[type="email"],
    input[type="password"] {
      padding: 12px;
      margin-bottom: 16px;
      border: 1px solid #ccc;
      border-radius: 8px;
      font-size: 16px;
    }

    .submit-btn {
      background: linear-gradient(90deg, #00c782 0%, #12986a 100%);
      color: white;
      border: none;
      padding: 12px;
      border-radius: 100px;
      font-size: 16px;
      cursor: pointer;
    }
  }
}
</style>
